import React from 'react';
import InfoChip from '@/components/ui/InfoChip';
import { useMe } from '@/context/MeContext';
import { useWorkspace } from '@/context/WorkspaceContext';
import { buildSidebarIdentity } from '@/utils/sidebarIdentity';

export default function SidebarIdentity() {
  const { me } = useMe();
  const { isPersonalMode, activeWorkspaceName, canSwitchWorkspace } = useWorkspace();

  if (!me) return null;

  const identity = buildSidebarIdentity(me, {
    isPersonalMode,
    activeWorkspaceName,
    canSwitchWorkspace,
  });

  return (
    <div className="sidebar-identity" aria-label="Signed-in user">
      <div className="sidebar-identity__name">{identity.displayName}</div>
      <div className="sidebar-identity__context muted">{identity.contextLine}</div>
      <div className="sidebar-identity__chips">
        {identity.showReadOnly ? (
          <InfoChip variant="warning" title="Read-only access">
            Read-only
          </InfoChip>
        ) : null}
        {identity.chips.map((chip) => (
          <InfoChip key={chip.key} variant={chip.variant}>
            {chip.key === 'plan' ? `Plan: ${chip.label}` : chip.label}
          </InfoChip>
        ))}
      </div>
    </div>
  );
}
